/* global google, MarkerClusterer */

(function() {
  "use strict";

  angular
    .module("app")
    .controller("AssetMapController", [
      "$scope",
      "$q",
      "$http",
      "$timeout",
      "$location",
      "$attrs",
      "NgMap",
      "AssetsService",
      "LoadingService",
      AssetMapController
    ]);

  // This controller exists alongside the RiskRankingMapController, adding additional functionality
  // to handle assets and map marker interaction
  function AssetMapController(
    $scope,
    $q,
    $http,
    $timeout,
    $location,
    $attrs,
    NgMap,
    AssetsService,
    LoadingService
  ) {
    var pinPath =
        "M0-31c-6.6,0-12,5.3-12,11.8C-12-14-4.6-4.5-1.4-0.7C-1.1-0.3-0.5,0,0,0s1.1-0.2,1.4-0.7C4.6-4.5,12-14,12-19.2C12-25.7,6.6-31,0-31zM0-14.9c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S2.2-14.9,0-14.9z",
      pinPathSolid =
        "M0-31c-6.6,0-12,5.3-12,11.8C-12-14-4.6-4.5-1.4-0.7C-1.1-0.3-0.5,0,0,0s1.1-0.2,1.4-0.7C4.6-4.5,12-14,12-19.2C12-25.7,6.6-31,0-31z",
      overlapDistance = 3,
      maxClusterZoom = 13;

    $scope.markerClusters = {};
    $scope.markerOverlappers = {};
    $scope.markerStash = {};
    $scope.markerReference = {};

    function standardIcon(color) {
      return {
        path: pinPath,
        labelOrigin: new google.maps.Point(0, -18),
        fillColor: color,
        fillOpacity: 1,
        scale: 1,
        strokeColor: "#e1e9eb",
        strokeWeight: 1
      };
    }

    function solidIcon(color) {
      var icon = standardIcon(color);
      icon.path = pinPathSolid;
      return icon;
    }

    // Change the marker style back to normal
    function standardizeMarkerStyle(m) {
      m.setIcon(standardIcon(m.icon.fillColor));
      m.setLabel({
        text: " ",
        color: "white"
      });
    }

    // Add a count to the marker pin
    function countifyMarkerStyle(m, count) {
      m.setIcon(solidIcon(m.icon.fillColor));
      m.setLabel({
        text: count.toString(),
        color: "white"
      });
    }

    var markerClusterer = {
      // Create a new marker cluster for a domain id, if one doesn't exist already
      // This gives us a reference for adding/removing individual markers per domain later on
      create: function(id) {
        // Add an overlapping marker spiderfier
        if (!$scope.markerOverlappers[id]) {
          $scope.markerOverlappers[id] = new OverlappingMarkerSpiderfier(
            $scope.map,
            {
              nearbyDistance: overlapDistance
            }
          );

          // On spiderfy, remove the special number style
          $scope.markerOverlappers[id].addListener("spiderfy", function(m) {
            m.forEach(function(m) {
              m.color = "black";
              m.data.countLabel = m.label.text;
              standardizeMarkerStyle(m);
            });
          });

          // On Unspiderfy, change back to special number style
          $scope.markerOverlappers[id].addListener("unspiderfy", function(m) {
            m.forEach(function(m) {
              countifyMarkerStyle(m, m.data.countLabel);
              m.data.countLabel = undefined;
            });
          });
        }

        $scope.markerClusters[id] =
          $scope.markerClusters[id] ||
          new MarkerClusterer(
            $scope.map,
            null, // This param is usually new markers; we'll add our own later
            {
              gridSize: 90,
              maxZoom: maxClusterZoom,
              groupPredicate: function(m1, m2) {
                var currentZoom = this.map.zoom;
                // Above this zoom level, only group within CD boundaries
                if (currentZoom >= 12) {
                  return (
                    m1.data.communityDistrictId === m2.data.communityDistrictId
                  );
                }
                return true;
              },
              styles: [
                {
                  fontFamily: "GestaCond-Bold",
                  url: "",
                  height: 36,
                  width: 36,
                  fontSize: "16px",
                  textColor: "#e1e9eb",
                  lineHeight: "32px",
                  backgroundColor: "#" + $scope.state.domainsByName[id].color,
                  border: "3px solid #e1e9eb",
                  borderRadius: "40px"
                }
              ]
            }
          );
      },

      // Adds markers by array for more efficient processing
      addMarkers: function(domain, arr) {
        var markerArr = [];

        arr.forEach(function(marker) {
          if (marker.data.isArea) {
            marker.polygon.data = marker.data;
            $scope.markerReference[marker.id] = marker.polygon;
          }
          else {
            marker.mapMarker.data = marker.data;
            markerArr.push(marker.mapMarker);
            $scope.markerReference[marker.id] = marker.mapMarker;
          }
        });

        $scope.markerClusters[domain].addMarkers(markerArr);
        markerArr.forEach(function(m) {
          $scope.markerOverlappers[domain].addMarker(m);
        });
      },

      // Removes markers by array for more efficient processing
      removeMarkers: function(domain, arr) {
        var markerArr = [];

        arr.forEach(function(marker) {
          if ($scope.markerReference[marker].data.isArea) {
            $scope.markerReference[marker].setMap(null);
          }

          // Add each marker to the removal array, then remove it from our reference arrays
          markerArr.push($scope.markerReference[marker]);

          var ind = $scope.markerStash[domain].indexOf(marker);
          $scope.markerStash[domain].splice(ind, 1);
          delete $scope.markerReference[marker];
        });

        if ($scope.markerClusters[domain]) {
          $scope.markerClusters[domain].removeMarkers(markerArr);
        }
      }
    };

    // Calculate pixel position of any point on the map
    function fromLatLngToPixel(position) {
      var scale = Math.pow(2, $scope.map.getZoom());
      var proj = $scope.map.getProjection();
      var bounds = $scope.map.getBounds();

      var nw = proj.fromLatLngToPoint(
        new google.maps.LatLng(
          bounds.getNorthEast().lat(),
          bounds.getSouthWest().lng()
        )
      );
      var point = proj.fromLatLngToPoint(position);

      return new google.maps.Point(
        Math.floor((point.x - nw.x) * scale),
        Math.floor((point.y - nw.y) * scale)
      );
    }

    // Square of distance between 2 points
    function ptDistanceSq(pt1, pt2) {
      var dx, dy;

      dx = pt1.x - pt2.x;
      dy = pt1.y - pt2.y;
      return dx * dx + dy * dy;
    }

    // Find markers that are overlapping
    function markerIndexesNearMarker(markers, marker) {
      var pxSq = overlapDistance * overlapDistance,
        markerPt = fromLatLngToPixel(marker.position);

      return markers.reduce(function(accum, m, i) {
        if (m === marker || !m.getVisible()) {
          return accum;
        }
        var mPt = fromLatLngToPixel(
          m._omsData ? m._omsData.usualPosition : m.position
        );
        return ptDistanceSq(mPt, markerPt) < pxSq ? accum.concat(i) : accum;
      }, []);
    }

    // Group all markers that overlap each other
    function groupOverlappingMarkers(markers) {
      var skip = markers.map(function() {
          return false;
        }),
        groups = [];

      for (var i = 0; i < markers.length; i++) {
        if (skip[i]) continue;
        var overlaps = markerIndexesNearMarker(markers.slice(i), markers[i]);

        if (overlaps.length > 0) {
          var group = [markers[i]].concat(
            overlaps.map(function(mi) {
              return markers[i + mi];
            })
          );
          overlaps.forEach(function(mi) {
            skip[i + mi] = true;
          });
          groups.push(group);
        }
      }
      return groups;
    }

    // Find and style any overlapping markers
    var findAndStyleOverlappingMarkers = _.debounce(function() {
      // Unspiderfy any spiderfied markers to avoid errors
      Object.keys($scope.markerOverlappers).forEach(function(key) {
        $scope.markerOverlappers[key].unspiderfy();
      });

      // Don't do anything if we're in a clustered zoom level
			if ($scope.map && $scope.map.getZoom() <= maxClusterZoom) {
        return;
      }

      var mapBounds = $scope.map.getBounds();

      // For every marker clusterer
      Object.keys($scope.markerClusters).forEach(function(key) {
        // Filter down to just the pins that are in view, for performance
        var pinsInView = $scope.markerClusters[key]
          .getMarkers()
          .filter(function(m) {
            return mapBounds.contains(m.position);
          });

        // Group these pins by overlapping
        var groupedPins = groupOverlappingMarkers(pinsInView);

        // Style each pin with the count in the group
        groupedPins.forEach(function(g) {
          g.forEach(function(m) {
            countifyMarkerStyle(m, g.length);
          });
        });
      });
    }, 100);

    // Find an asset's direct parent
    // This will either return a parent asset array, or nothing if the asset is a parent or has no children
    $scope.findAssetParent = function(assetId) {
      return Object.keys($scope.state.assetsByGroup).filter(function(group) {
        return $scope.state.assetsByGroup[group].indexOf(assetId) > -1;
      });
    };

    // When the selected assets change, make an API request to load asset + marker data
    $scope.$watch(
      "state.selectedAssets",
      function(newValue, oldValue) {
        // Quick exit on initialization, not everything will be ready yet.
        // https://docs.angularjs.org/api/ng/type/$rootScope.Scope
        // If `newValue` has length, that means `state.selectedAssets` was created from URL parameters,
        // so it's safe to execute the rest of the function
        if (!newValue.length && newValue === oldValue) {
          return false;
        }

        // Concatenate all selected assets together in the right format for making the API request
        var assetsByName = $scope.state.selectedAssets
          .map(function(assetId) {
            var assetParents = $scope.findAssetParent(assetId);
            if (assetParents.length > 1) {
              return (
                $scope.state.assetsById[assetParents[1]].name.trim() +
                "/" +
                $scope.state.assetsById[assetId].name.trim()
              );
            }
            else {
              return $scope.state.assetsById[assetId].name.trim();
            }
          })
          .join("|");

        // Update the URL with the new selected assets string
        $location.search("assets", assetsByName);

        var assetsLoadingId = LoadingService.taskStart(
          $scope,
          "Loading Assets"
        );

        AssetsService.getAssets(assetsByName).then(
          function(response) {
            LoadingService.taskEnd($scope, assetsLoadingId);

            var assetDrawingId = LoadingService.taskStart(
              $scope,
              "Drawing Asset Pins"
            );

            var newMarkers = {};
            var selectedAssetMarkers = [];
            var assetNumStash = {}; // so we don't bother $scope over and over
            $scope.state.numberOfAssets = {}; // reset the assets counter

            function processMarker(marker) {
              /* For sub-assets, an array of categories will be returned by the API, including any parent assets. The actual category is the last item in the array. Example:
                        category: [
                            'Parent Asset',
                            'Child Asset'
                        ]

                    Parent assets will not have assets of their own, but their total count should be
                    the sum of all their child assets. */

              if (!assetNumStash[marker.communityDistrictId]) {
                assetNumStash[marker.communityDistrictId] = {};
              }

              marker.category.forEach(function(category, ind, arr) {
                if (assetNumStash[marker.communityDistrictId][category]) {
                  assetNumStash[marker.communityDistrictId][category]++;
                }
                else {
                  assetNumStash[marker.communityDistrictId][category] = 1;
                }
              });

              // Sugar to make things a little more understandable
              var asset = $scope.state.assetsByName[marker.category[0]];
              var domain = $scope.state.domainsByAsset[asset.id];

              // Markers don't have IDs, so let's build our own from three unique data points:
              // - Marker description
              // - Latitude
              // - Longitude
              var markerID =
                marker.description + "-" + marker.lat + "-" + marker.long;
              selectedAssetMarkers.push(markerID);

              $scope.markerStash[domain] = $scope.markerStash[domain] || [];
              newMarkers[domain] = newMarkers[domain] || [];

              // If the marker doesn't already exist, add it to the stash and create it on the map
              if ($scope.markerStash[domain].indexOf(markerID) === -1) {
                $scope.markerStash[domain].push(markerID);

                var newMarker;
                var isArea =
                  marker.isArea &&
                  marker.assetId != null &&
                  marker.assetId != 0;
                if (!isArea && marker.lat && marker.long) {
                  newMarker = {
                    data: marker,
                    id: markerID,
                    asset: asset,
                    mapMarker: new google.maps.Marker({
                      position: {
                        lat: marker.lat,
                        lng: marker.long
                      },
                      label: {
                        text: " ",
                        color: "white"
                      },
                      icon: standardIcon(
                        "#" + $scope.state.domainsByName[domain].color
                      )
                    })
                  };

                  // On mouseover, we need to populate and display the marker info box
                  newMarker.mapMarker.addListener("mouseover", function() {
                    assetMouseOver(marker, $scope.map);
                  });
                  newMarker.mapMarker.addListener("mouseout", function() {
                    assetMouseOut();
                  });
                  newMarkers[domain].push(newMarker);
                }
                else if (isArea) {
                  var wkt = marker.shapeData;
                  var polygon = ccc.viz.map.util.MapUtil.wktToGooglePolygon(
                    wkt
                  );

                  polygon.setOptions({
                    fillColor: "#" + $scope.state.domainsByName[domain].color,

                    zIndex: 1000
                  });

                  polygon.addListener("mouseover", function() {
                    assetMouseOver(marker, $scope.map);

                    this.setOptions({
                      strokeColor: "#dea003",
                      strokeWeight: 3
                    });
                  });
                  polygon.addListener("mouseout", function() {
                    assetMouseOut();
                    this.setOptions({
                      strokeColor: "#e2ecec",
                      strokeWeight: 1
                    });
                  });

                  newMarker = {
                    data: marker,
                    id: markerID,
                    asset: asset,
                    polygon: polygon
                  };

                  polygon.setMap($scope.map);
                  newMarkers[domain].push(newMarker);
                }
              }
            }

            function assetMouseOver(marker, map) {
              $scope.map = map;
              var markerLatLng = new google.maps.LatLng(
                marker.lat,
                marker.long
              );
              var eventLoc = $scope.latLng2Point(markerLatLng, $scope.map);
              var domain =
                $scope.state.domainsByAsset[
                  $scope.state.assetsByName[marker.category[0]].id
                ];

              // Magic numbers to offset the box position for better UI
              $scope.mapHoverBox.posLeft = eventLoc.x + 40;
              $scope.mapHoverBox.posTop = eventLoc.y - 70;

              $scope.mapHoverBox.domainName = domain;
              $scope.mapHoverBox.domainIcon =
                $scope.state.domainsByName[domain].icon;

              // For all categories an asset has, create a pretty slash-separated string for the display name when a user hovers on the map marker.
              $scope.mapHoverBox.assetCategory = "";
              marker.category.forEach(function(category, ind, arr) {
                $scope.mapHoverBox.assetCategory += marker.category[ind];
                // Separate every category except for the last one, so no trailing slash
                if (ind !== marker.category.length - 1) {
                  $scope.mapHoverBox.assetCategory += " / ";
                }
              });

              $scope.mapHoverBox.assetDescription = marker.description;
              $scope.mapHoverBox.hoveredCommunity =
                $scope.state.communitiesById[marker.communityDistrictId];

              // The `isAsset` flag determines whether the hover pop-out displays community
              // info, or asset info. `isAsset` trumps community info
              $scope.mapHoverBox.isAsset = true;

              $scope.$apply();
            }

            function assetMouseOut() {
              $scope.mapHoverBox.isAsset = false;
              $scope.$apply();
            }

            // Batch the markers up in to groups and process them one group at a time, sequentially
            var batchSize = 75;
            function batchMarkers(accum, rest) {
              if (rest.length <= batchSize) {
                accum.push(rest);
                return accum;
              }

              accum.push(rest.slice(0, batchSize));
              return batchMarkers(accum, rest.slice(batchSize));
            }

            var batchedMarkers = batchMarkers([], response);

            // Process each batch at a time sequentially, with a settimeout on each batch process
            // This has the benefit of returning control to the browser after each batch is processed
            batchedMarkers
              .reduce(function(promise, batch) {
                return promise.then(function() {
                  return $timeout(function() {
                    batch.forEach(processMarker);
                  }, 0);
                });
              }, $q.when(true))
              .then(function() {
                $scope.state.numberOfAssets = assetNumStash;

                // Helper function to prevent race condition caused by trying to add markers
                // before the map promise resolves
                var buildNewMarkers = function(domain) {
                  var newMarkersArr = [];

                  for (var marker in newMarkers[domain]) {
                    newMarkersArr.push(newMarkers[domain][marker]);
                  }

                  markerClusterer.addMarkers(domain, newMarkersArr);
                };

                Object.keys(newMarkers).forEach(function(domain, ind, arr) {
                  // Create a new cluster of markers for this specific domain
                  // Sometimes this fires before the map has made it into scope; check for that
                  if (!$scope.map) {
                    NgMap.getMap().then(function(map) {
                      $scope.map = map;
                      markerClusterer.create(domain, map);

                      buildNewMarkers(domain);
                    });
                  }
                  else {
                    markerClusterer.create(domain, $scope.map);
                    buildNewMarkers(domain);
                  }
                });

                // The `markerStash` lets us know all the markers we just added. Since `state.selectedAssets`
                // changed, and we might need to remove assets too, compare `markerStash` to the
                // `selectedAssetMarkers` array. Any markers that aren't found can be presumed removed.
                Object.keys($scope.markerStash).forEach(function(
                  domain,
                  ind,
                  arr
                ) {
                  var removeThese = [];

                  $scope.markerStash[domain].forEach(function(marker) {
                    if (selectedAssetMarkers.indexOf(marker) === -1) {
                      removeThese.push(marker);
                    }
                  });

                  markerClusterer.removeMarkers(domain, removeThese);
                });

                LoadingService.taskEnd($scope, assetDrawingId);

                findAndStyleOverlappingMarkers();

                if ($attrs.assetMap) {
						// At this point, the map should be all done rendering
						$timeout(function () {
                    if ($scope.currentURL.search().cap) {
                      window.triggerScreenshot();
                    }
                  }, 1000);
                }
              });
          },
          function(response) {
            console.warn("getAssets failed!");
          }
        );
      },
      true
    ); // compares equality, not reference

    // Attach map listeners to process any overlapping markers
    var attachMapListeners = _.once(function() {
      var lastZoom = $scope.map.getZoom();
      var zoomedInCount = 0;
      google.maps.event.addListener(
        $scope.map,
        "zoom_changed",
        function trackMapZoom() {
          // Tracks when a user clicks on zoom on a map 3 or more times on the "Asset Mapping" page.
          var curZoom = $scope.map.getZoom();

          if (curZoom > lastZoom) {
            zoomedInCount += 1;

            if (zoomedInCount >= 3) {
              dataLayer.push({
                event: "3 or More Map Zoom",
                eventCategory: "Interactive Clicks",
                eventAction: "3 or More Map Zoom",
                eventLabel: window.location.pathname
              });
            }
          }
          else if (curZoom < lastZoom) {
            zoomedInCount -= 1;
          }

          lastZoom = curZoom;
        }
      );

      google.maps.event.addListener($scope.map, "zoom_changed", function() {
        findAndStyleOverlappingMarkers();
      });

      google.maps.event.addListener($scope.map, "center_changed", function() {
        findAndStyleOverlappingMarkers();
      });
    });

    $scope.$watch("map", function() {
      if ($scope.map) {
        attachMapListeners();
      }
    });
  }
})();
